export const apiKey = 'AIzaSyDVYHg-PK04jIUME236CukvytlFEUoKyEw';
export const authDomain = 'expense-book-4afdc.firebaseapp.com';
export const projectId = 'expense-book-4afdc';
export const storageBucket = 'expense-book-4afdc.appspot.com';
export const messagingSenderId = '385937511067';
export const appId = '1:385937511067:web:068f275949f1681f056c3e';
